/**
 * Founder Control Center v2 · Sección 1 · Dashboard Principal.
 *
 * Reutiliza FounderHome (KPIs unificados + North Star + Health Score + Funnel +
 * IA snapshot). Entrada por defecto del Founder Control Center.
 *
 * Convergence Sprint · Feb 2026 · 0% código nuevo, solo wrapper que delega.
 */
import FounderHome from "../FounderHome";

export default function DashboardSection() {
  return (
    <div data-testid="fcc-dashboard-section">
      <FounderHome />
    </div>
  );
}
